import { render, staticRenderFns } from "./invoice-pdf-header.vue?vue&type=template&id=dc365602&scoped=true&"
import script from "./invoice-pdf-header.vue?vue&type=script&lang=ts&"
export * from "./invoice-pdf-header.vue?vue&type=script&lang=ts&"
import style0 from "./invoice-pdf-header.vue?vue&type=style&index=0&id=dc365602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc365602",
  null
  
)

export default component.exports